/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    google: {
        families: ['Red+Hat+Display:400,500,700', 'Barlow:700', 'Red+Hat+Text:400,500&display=swap']
    }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

smoothScroll();

initAnimations();

//--------------------------------------------------------------------//



// Import Componenti
//--------------------------------------------------------------------//

import initHeader from 'components/header/header';

import breadcrumbs from 'components/breadcrumbs/breadcrumbs';

import accordion from 'components/accordion/accordion';

import languagesList from 'components/languages-list/languages-list';

import footer from 'components/footer/footer';

import buttons from 'components/buttons/buttons';

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

initHeader();

breadcrumbs();

accordion();

//--------------------------------------------------------------------//